import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Actuator } from '../../models/Actuator';
import { Motor } from '../../models/Motor';
import { FeedbackCode } from '../../models/FeedbackCode';
import { MFG } from '../../models/MFG';
import { Drive } from '../../models/Drive';
import { Connector } from '../../models/Connector';
import { ConnectorPin } from '../../models/CablePin';
import { Cable } from '../../models/Cable';
import { faArrowRotateLeft, faArrowRight, faFilePdf, faFileExcel, faGear, faBolt } from '@fortawesome/free-solid-svg-icons';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MotordataComponent } from '../motordata/motordata.component';
import { FeedbackDevice } from '../../models/FeedbackDevice';
import { MFGDBColumn } from '../../models/MFGDBColumn';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

import pdfMake from 'pdfmake/build/pdfmake';
//import { pdfMake } from 'pdfmake/build/pdfmake';
//const pdfMake = require('pdfmake/build/pdfmake');
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { ExcelConverter } from 'pdfmake-to-excel';
import { ConversionService } from '../../services/ConversionService';
import { UnitObject } from '../../models/UnitObject';
import { Unit } from '../../models/Enums';
import { IPayload } from 'pdfmake-to-excel/dist/interfaces/IPayload.interface';
import { ExcelService } from '../../services/ExcelService';
import * as ExcelJS from 'exceljs';
import { DBColumn } from '../../models/DBColumn';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrl: './results.component.css'
})
export class ResultsComponent implements OnInit {
  @Input() Actuator: Actuator;
  @Input() Motor: Motor;
  @Input() Feedback: FeedbackCode;
  @Input() Manufacturer: MFG;
  @Input() TolomaticMFG: MFG;
  @Input() Drive: Drive;
  @Input() Connectors: Connector[];
  @Input() BrakeSelected: boolean;
  @Input() Cables: Cable[];
  @Input() PowerCableImage: string;
  @Input() FeedbackCableImage: string;
  @Input() HybridCableImage: string;
  @Input() FeedbackDevice: FeedbackDevice;
  @Input() HideSuggestedCables: boolean;
  @ViewChild("divForPDF", { static: false }) divForPDF: ElementRef;

  faArrowRotateLeft = faArrowRotateLeft;
  faArrowRight = faArrowRight;
  faFilePDF = faFilePdf;
  faFileExcel = faFileExcel;
  faGear = faGear;
  faBolt = faBolt;

  
  constructor(public dialog: MatDialog, private convServ: ConversionService, private excelService:ExcelService) {

    this.Actuator = new Actuator();
    this.Motor = new Motor();
    this.Feedback = new FeedbackCode();
    this.FeedbackDevice = new FeedbackDevice();
    this.Manufacturer = new MFG();
    this.TolomaticMFG = new MFG();
    this.Drive = new Drive();
    this.Connectors = [];
    this.BrakeSelected = false;
    this.Cables = [];
    this.PowerCableImage = "";
    this.FeedbackCableImage = "";
    this.HybridCableImage = "";
    this.HideSuggestedCables = false;
  }

  async ngOnInit() {

   

  }

  GetSpecificCable(cType: string): Cable {
    if (this.Cables.some(x => x.CableType == cType)) {
      return this.Cables.filter(x => x.CableType == cType)[0];
    }
    else {
      return new Cable();
    }
  }

  GetSpecificConnector(cableType: string): Connector {
    if (this.Connectors.some(x => x.CableType == cableType)) {
      return this.Connectors.filter(x => x.CableType == cableType)[0];
    } else {
      return new Connector();
    }
  }

  GetSpecificConnectorPins(cType: string): ConnectorPin[] {
    if (this.Connectors.some(x => x.CableType == cType)) {
      var pins = this.Connectors.filter(x => x.CableType == cType)[0].Pins;
      return pins;
    }
    else {
      return [];
    }
  }

  getUniqueDriveSeries(drives: Drive[]): string[] {

    const retArray = drives.map(x => x.Series);

    const unique = new Set(retArray);
    const uniqueArray = [...unique];

    return uniqueArray.sort();
  }

  MotorData_Click() {
    var columnsToSend = this.Drive.MFG.MFGDBColumns.filter(x => x.DBTable.toLowerCase() == "motor");
    if (columnsToSend.length == 0) {
      columnsToSend = this.TolomaticMFG.MFGDBColumns.filter(x => x.DBTable.toLowerCase() == "motor");
    }
    const dialogRef = this.dialog.open(MotordataComponent, {
      width: '50%', data: { selectedAct: this.Actuator, selectedMot: this.Motor, columns: columnsToSend, objectType: "Motor" }
    });
  }

  FeedbackData_Click() {

    var columnsToSend = this.GetFeedbackColumns(this.Drive.MFG.MFGDBColumns);
    if (columnsToSend.length == 0) {
      columnsToSend = this.GetFeedbackColumns(this.TolomaticMFG.MFGDBColumns);
    }

    const dialogRef = this.dialog.open(MotordataComponent, {
      width: '50%', data: { selectedFeedbackDevice: this.FeedbackDevice, selectedFeedback: this.Feedback, columns: columnsToSend, objectType: "Feedback" }
    });
  }

  GetFeedbackColumns(columns: MFGDBColumn[]): MFGDBColumn[] {
    var retColumns = [];

    retColumns = columns.filter(x => x.DBTable.toLowerCase() == "feedbackdevice" && (x.FeedbackCode.indexOf(this.FeedbackDevice.FeedbackCode) >= 0 || x.FeedbackCode == "" || x.FeedbackCode.toLowerCase() == "all"));
    return retColumns;
  }

  async ExportToExcel() {
    var currentRowCount = 0;
    var powerIMGIndex = 0;
    var feedbackIMGIndex = 0;
    var hybridIMGIndex = 0;
    const workBook = new ExcelJS.Workbook();
    const workSheet = workBook.addWorksheet("Sheet 1");
    workSheet.columns = [
      { width: 50 },
      {},
      {width:20}
    ];
    var header = [this.Actuator.Name + " " + this.Motor.Name + " " + this.Feedback.Code + (this.BrakeSelected ? "B" : "N").toString()];
    workSheet.addRow(header);
    //workSheet.getColumn(0).width = 200;
    currentRowCount++;
    workSheet.addRow([this.Drive.MFG.Name + " " + this.Drive.Series]);
    currentRowCount++;
    if (this.Connectors.length <= 1) {//Hybrid
      if (this.Feedback.Code.startsWith("D")) {//IMA
        workSheet.addRow(["Suggested Hybrid Cable: ", this.GetSpecificCable('Power').Name]);
        currentRowCount++;
        workSheet.addRow(["Suggested Hybrid Cable: ", this.GetSpecificCable('Power').Name]);
        currentRowCount++;
        workSheet.addRow(["Actuator Hybrid Connector", "", "", "Pin", "Signal"])
        currentRowCount++;
      } else {//IMAS
        if (this.Feedback.Code == 'CA2A2' || this.Feedback.Code == 'CT2A2') {
          workSheet.addRow(["Suggested Hybrid Cable: ", "Contact Tolomatic"]);
          currentRowCount++;
          workSheet.addRow(["Actuator Hybrid Connector", "", "", "Pin", "Signal"]);
          currentRowCount++;
        }
        else {
          workSheet.addRow(["Actuator Hybrid Cable", "", "", "Pin", "Signal"]);
          currentRowCount++;
        }        
      }
      var hybridPins = this.GetSpecificConnectorPins('Hybrid');
      var hybridConn = this.GetSpecificConnector('Hybrid');
      var hybridImageID = workBook.addImage({
        base64: await this.getBase64ImageFromURL('./assets/images/' + this.HybridCableImage, 200, 200),
        extension: 'png'
      });

      for (var i = 0; i < hybridPins.length; i++) {
        if (i == 0) {//add Connector MFG
          workSheet.addRow(["Manufacturer: " + hybridConn.Manufacturer.Name, "", "", hybridPins[i].PinID, hybridPins[i].Signal]);
        } else if (i == 1) {//add connector PN
          workSheet.addRow(["Part Number: " + hybridConn.ConnectorPN, "", "", hybridPins[i].PinID, hybridPins[i].Signal]);
          hybridIMGIndex = currentRowCount + 2;
        } else {
          workSheet.addRow(["", "", "", hybridPins[i].PinID, hybridPins[i].Signal]);
        }
        currentRowCount++;
      }
      workSheet.addImage(hybridImageID, 'B' + (hybridIMGIndex ).toString() + ':C' + (hybridIMGIndex + 5).toString());

    } else {//Power/Feedback
      if (this.Feedback.Code.startsWith("D")) {
        workSheet.addRow(["Suggested Power Cable: ", this.GetSpecificCable('Power').Name]);
        currentRowCount++;
        workSheet.addRow(["Suggested Feedback Cable: ", this.GetSpecificCable('Feedback').Name]);
        currentRowCount++;
        workSheet.addRow(["Actuator Power Connector", "", "", "Pin", "Signal"])
        currentRowCount++;
      }
      else {
        workSheet.addRow(["Actuator Power Cable", "", "", "Pin", "Signal"])
        currentRowCount++;
      }

      var powerPins = this.GetSpecificConnectorPins('Power');
      var powerConn = this.GetSpecificConnector('Power');
      var powerImageID = workBook.addImage({
        base64: await this.getBase64ImageFromURL('./assets/images/' + this.PowerCableImage, 200, 200),
        extension: 'png'
      });
      for (var i = 0; i < powerPins.length; i++) {
        if (i == 0) {//add Connector MFG
          workSheet.addRow(["Manufacturer: " + powerConn.Manufacturer.Name, "", "", powerPins[i].PinID, powerPins[i].Signal]);
        } else if (i == 1) {//add connector PN
          workSheet.addRow(["Part Number: " + powerConn.ConnectorPN, "", "", powerPins[i].PinID, powerPins[i].Signal]);
          powerIMGIndex = currentRowCount + 2;
        } else {
          workSheet.addRow(["", "", "", powerPins[i].PinID, powerPins[i].Signal]);
        }
        currentRowCount++;
      }

      //fix for power image extending into feedback area
      if (currentRowCount < powerIMGIndex + 5) {
        for (var i = powerIMGIndex + 5 - currentRowCount; i >= 0; i--) {
          workSheet.addRow([""]);
        }
        currentRowCount = powerIMGIndex + 5;
      }
      if (this.Feedback.Code.startsWith("D")) {
        workSheet.addRow(["Actuator Feedback Connector", "", "", "Pin", "Signal"]);
      }
      else {
        workSheet.addRow(["Actuator Feedback Cable", "", "", "Pin", "Signal"]);
      }
      
      currentRowCount++;
      var feedbackPins = this.GetSpecificConnectorPins('Feedback');
      var feedbackConn = this.GetSpecificConnector('Feedback');
      var feedbackImageID = workBook.addImage({
        base64: await this.getBase64ImageFromURL('./assets/images/' + this.FeedbackCableImage,200,200),
        extension: 'png'
      });

      for (var i = 0; i < feedbackPins.length; i++) {
        if (i == 0) {//add Connector MFG
          workSheet.addRow(["Manufacturer: " + feedbackConn.Manufacturer.Name, "", "", feedbackPins[i].PinID, feedbackPins[i].Signal]);
        } else if (i == 1) {//add connector PN
          workSheet.addRow(["Part Number: " + feedbackConn.ConnectorPN, "", "", feedbackPins[i].PinID, feedbackPins[i].Signal]);
          feedbackIMGIndex = currentRowCount + 2;
        }  else {
          workSheet.addRow(["", "", "", feedbackPins[i].PinID, feedbackPins[i].Signal]);
        }
        currentRowCount++;
      }
      workSheet.addImage(powerImageID, 'B' + (powerIMGIndex).toString() + ':C' + (powerIMGIndex + 5).toString());
      workSheet.addImage(feedbackImageID, 'B' + (feedbackIMGIndex).toString() + ':C' + (feedbackIMGIndex + 5).toString());
    }

    //Motor/Feedback data
    //add row for space
    workSheet.addRow([""]);
    currentRowCount++;
    workSheet.addRow(["Motor Spec Data"]);
    currentRowCount++;
    var motorData = this.GetSpecRowsForExcel('Motor');
    for (var i = 0; i < motorData.length; i++) {
      var specData = motorData[i];
      var label = specData[0];
      var data = specData[1];
      workSheet.addRow([label, data]);
      currentRowCount++;
    }
    workSheet.addRow([""]);
    currentRowCount++;
    workSheet.addRow(["Feedback Spec Data"]);
    currentRowCount++;


    var feedbackData = this.GetSpecRowsForExcel('Feedback');
    for (var i = 0; i < feedbackData.length; i++) {
      var specData = feedbackData[i];
      var label = specData[0];
      var data = specData[1];
      workSheet.addRow([label, data]);
      currentRowCount++;
    }

    this.excelService.generateExcelFile(workBook, this.Actuator.Name + " " + this.Motor.Name + " " + this.Feedback.Code + (this.BrakeSelected ? "B" : "N").toString());
  }

  async GetPDFContent(): Promise<any[]> {
    var content: any[] = [];

    content.push({
      text: this.Actuator.Name + " " + this.Motor.Name + " " + this.Feedback.Code + (this.BrakeSelected ? "B" : "N").toString(),
      fontSize: 20,
      alignment: "left",
      bold: true
    });
    content.push({
      text: this.Drive.MFG.Name + " " + this.Drive.Series,
      fontSize: 18,
      alignment: "left",
      bold: true
    })


    //cables
    var isHybridCable = this.Connectors.length == 1;
    if (!isHybridCable) {
      content.push({
        text: "Suggested Power Cable: " + this.GetSpecificCable("Power").Name,
        fontSize: 16,
        alignment: "left",
        bold: true,
        style: "defaultStyle"
      },
        {
          text: "Suggested Feedback Cable: " + this.GetSpecificCable("Feedback").Name,
          fontSize: 16,
          alignment: "left",
          bold: true,
          style: "defaultStyle"
        });
    }
    else {

      if (this.Actuator.Name.startsWith("IMAS")) {
        content.push({
          text: "Suggested Hybrid Cable: Contact Tolomatic",
          fontSize: 16,
          alignment: "left",
          bold: true,
          style: "defaultStyle"
        });
      }
      else {
        content.push({
          text: "Suggested Hybrid Cable: " + this.GetSpecificCable("Hybrid").Name,
          fontSize: 16,
          alignment: "left",
          bold: true,
          style: "defaultStyle"
        });
      }
      
    }

    //Power Connector
    var leftColumn: any[] = [];
    var rightcolumn: any[] = [];
    var FBrightcolumn: any[] = [];
    var FBleftColumn: any[] = [];
    if (!isHybridCable) {

      leftColumn.push(
        {
          text: "Actuator Power Connector",
          fontSize: 18,
          alignment: "left",
          bold: true,
          width: "60%",
          style: "defaultStyle"
        }
        ,
        {
          text: "Manufacturer: " + this.GetSpecificConnector("Power").Manufacturer.Name,
          fontSize: 14,
          alignment: "left",
          bold: true,
          width: "60%",
          style: "defaultStyle"
        }
        ,
        {
          text: "Part Number: " + this.GetSpecificConnector("Power").ConnectorPN,
          fontSize: 14,
          alignment: "left",
          bold: true,
          width: "60%",
          style: "defaultStyle"
        }
        ,
        {
          alignment: "center",
          image: await this.getBase64ImageFromURL("./assets/images/" + this.PowerCableImage, 160, 160),
          width: "160",
          height: "160",
          fit: [160, 160]
        }
      );

      //pinout

      var powPinout = this.GetPinoutRows("Power");
      if (powPinout.length > 0) {
        rightcolumn.push({

          width: "40%",
          layout: "lightHorizontalLines",
          alignment: "center",
          table: {
            widths: ["50%", "50%"],
            headerRows: 1,
            body: powPinout
          }

        });
      }
      content.push({
        columns: [leftColumn, rightcolumn]
      });

      //Feedback Connector

      FBleftColumn.push(
        {
          text: "Actuator Feedback Connector",
          fontSize: 18,
          alignment: "left",
          bold: true,
          width: "50%",
          style: "defaultStyle"
        }
        ,
        {
          text: "Manufacturer: " + this.GetSpecificConnector("Feedback").Manufacturer.Name,
          fontSize: 14,
          alignment: "left",
          bold: true,
          width: "50%",
          style: "defaultStyle"
        }
        ,
        {
          text: "Part Number: " + this.GetSpecificConnector("Feedback").ConnectorPN,
          fontSize: 14,
          alignment: "left",
          bold: true,
          width: "50%",
          style: "defaultStyle"
        }
        ,
        {

          alignment: "center",
          image: await this.getBase64ImageFromURL("./assets/images/" + this.FeedbackCableImage, 200, 200),
          width: "200",
          height: "200",
          fit: [200, 200]
        }
      );

      //pinout

      var fbPinout = this.GetPinoutRows("Feedback");

      if (fbPinout.length > 0) {
        FBrightcolumn.push({
          layout: "lightHorizontalLines",
          alignment: "center",
          table: {
            widths: ["50%", "50%"],
            headerRows: 1,
            body: fbPinout
          }
        });
      }
      content.push({
        columns: [FBleftColumn, FBrightcolumn]
      });
    }
    else {
      leftColumn.push(
        {
          text: "Actuator Hybrid Connector",
          fontSize: 18,
          alignment: "left",
          bold: true,
          width: "60%",
          style: "defaultStyle"
        }
        ,
        {
          text: "Manufacturer: " + this.GetSpecificConnector("Hybrid").Manufacturer.Name,
          fontSize: 14,
          alignment: "left",
          bold: true,
          width: "60%",
          style: "defaultStyle"
        }
        ,
        {
          text: "Part Number: " + this.GetSpecificConnector("Hybrid").ConnectorPN,
          fontSize: 14,
          alignment: "left",
          bold: true,
          width: "60%",
          style: "defaultStyle"
        }
        ,
        {
          alignment: "center",
          image: await this.getBase64ImageFromURL("./assets/images/" + this.HybridCableImage, 160, 160),
          width: "160",
          height: "160",
          fit: [160, 160]
        }
      );


      rightcolumn.push({

        width: "40%",
        layout: "lightHorizontalLines",
        alignment: "center",
        table: {
          widths: ["50%", "50%"],
          headerRows: 1,
          body: this.GetPinoutRows("Hybrid")
        }

      });
      content.push({
        columns: [leftColumn, rightcolumn]
      });

    }

    //Spec Data
    var specColumns: any[] = [];
    var lSpecColumn: any[] = [];
    var rSpecColumn: any[] = [];
    //motor spec data
    lSpecColumn.push({ text: "Motor Spec Data" },
      {
        layout: "lightHorizontalLines",
        alignment: 'center',
        table: {
          widths: ["50%", "50%"],
          headerRows: 0,
          body: this.GetSpecRows("Motor")
        }
      }
    );

    //feedback spec data
    rSpecColumn.push({ text: "Feedback Spec Data" },
      {
        layout: "lightHorizontalLines",
        alignment: 'center',
        table: {
          widths: ["50%", "50%"],
          headerRows: 0,
          body: this.GetSpecRows("FeedbackDevice")
        }
      }
    );

    content.push({
      pageBreak: "before",
      columns: [lSpecColumn, rSpecColumn]
    });

    return content;
  }

  async GeneratePDF() {
    var header: any[] = [];
    var headerBase64 = await this.getBase64ImageFromURL('./assets/images/TolomaticLogo2Ccmyk_193px.png', undefined, undefined);

    var headerContent = {
      image: headerBase64,
      alignment: "center"
    };

    header.push(headerContent);

    let docDefinition: TDocumentDefinitions = {
      pageSize: 'A4',

      pageMargins: [20, 60, 20, 40],
      styles: {
        tableHeader: {
          //alignment: 'center',
          fontSize: 12,
          bold: true,
          marginTop: 2,
          marginBottom: 2
        },
        tableCell: {
          fontSize: 10,
          marginTop: 2,
          marginBottom: 2
        },
        defaultStyle: {
          marginTop: 5
        }
      },
      footer: function (curPage: number, pageCount: number) {
        return [{
          text: "Tolomatic * County Road 116 * Hamel, MN 55340 * 763-478-8000 * 1-800-328-2174",
          fontSize: 8,
          alignment: 'center'
        }, {
          text: "Page " + curPage.toString(),
          fontSize: 8,
          alignment: 'center'
        }];
      },
      header: function (curPage: number, pageCount: number) {
        return header;
      },
      content: []
    };



    docDefinition.content = await this.GetPDFContent();

    var fileName = this.Actuator.Name + "_" + this.Motor.Name + "_" + this.Feedback.Code + (this.BrakeSelected ? "B" : "N").toString();
    pdfMake.createPdf(docDefinition).download(fileName);
  }

  getBase64ImageFromURL(url: string, height?: number, width?: number): Promise<string> {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        var canvas = document.createElement("canvas");
        if (height && width) {
          var imgW = img.width;
          var imgH = img.height;
          var scale = Math.min((width / imgW), (height / imgH));
          var iwScaled = imgW * scale;
          var ihScaled = imgH * scale;
          canvas.width = iwScaled;
          canvas.height = ihScaled;


          var ctx = canvas.getContext("2d");
          if (ctx != null) {
            ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
          }
        }
        else {
          canvas.width = img.width;
          canvas.height = img.height;

          var ctx = canvas.getContext("2d");
          if (ctx != null) {
            ctx.drawImage(img, 0, 0);
          }
        }

        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = error => {
        reject(error);
      };
      img.src = url;
    });
  }

  GetPinoutRows(connectorType: string): any[] {
    var finalArray: any[] = [];

    var conn = this.GetSpecificConnectorPins(connectorType);

    finalArray.push([{ text: "Pin ID", style: 'tableHeader' },
    { text: "Signal", style: 'tableHeader' }
    ]);
    for (var i = 0; i < conn.length; i++) {
      finalArray.push([{ text: conn[i].PinID, style: 'tableCell' },
      { text: conn[i].Signal, style: 'tableCell' }
      ]);
    }

    return finalArray;
  }

  GetSpecRows(specType: string): any[] {
    var finalArray: any[] = [];
    var dbTable = specType == "Motor" ? "Motor" : "FeedbackDevice";
    var columns;
    if (specType == "Motor") {
      columns =  this.Drive.MFG.MFGDBColumns.filter(x => x.DBTable == dbTable);
    }
    else {
      columns = this.GetFeedbackColumns(this.Drive.MFG.MFGDBColumns.filter(x => x.DBTable == dbTable))
      if (columns.length == 0) {
        columns = this.GetFeedbackColumns(this.TolomaticMFG.MFGDBColumns.filter(x => x.DBTable == dbTable))
      }
    }
    if (columns.length > 0) {
      for (var i = 0; i < columns.length; i++) {
        var currentColumn: MFGDBColumn = columns[i];
        finalArray.push([{ text: currentColumn.CustomText == "" ? currentColumn.DBColumn.DisplayText : currentColumn.CustomText, style: 'tableCell' },
        { text: (this.GetDataValue(specType, currentColumn, currentColumn.DefaultValue) + " " + this.GetUnitDisplayUOM(this.convServ.GetUnitFromString(currentColumn.DefaultUOM != "" ? currentColumn.DefaultUOM : currentColumn.DBColumn.DefaultUOM), currentColumn)), style: 'tableCell' }
        ]);
      }
    }
    else {
      finalArray.push({ text: "No Spec Info" }, { text: "" });
    }



    return finalArray;
  }

  GetSpecRowsForExcel(specType: string): any[] {
    var finalArray: any[] = [];
    var dbTable = specType == "Motor" ? "Motor" : "FeedbackDevice";
    var columns;
    if (specType == "Motor") {
      columns = this.Drive.MFG.MFGDBColumns.filter(x => x.DBTable == dbTable);
      if (columns.length == 0) {
        columns = this.TolomaticMFG.MFGDBColumns.filter(x => x.DBTable == dbTable);
      }
    }
    else {
      columns = this.GetFeedbackColumns(this.Drive.MFG.MFGDBColumns.filter(x => x.DBTable == dbTable))
      if (columns.length == 0) {
        columns = this.GetFeedbackColumns(this.TolomaticMFG.MFGDBColumns.filter(x => x.DBTable == dbTable))
      }
    }
    if (columns.length > 0) {
      for (var i = 0; i < columns.length; i++) {
        var currentColumn: MFGDBColumn = columns[i];
        finalArray.push([currentColumn.CustomText == "" ? currentColumn.DBColumn.DisplayText : currentColumn.CustomText,
        this.GetDataValue(specType, currentColumn, currentColumn.DefaultValue) + " " + this.GetUnitDisplayUOM(this.convServ.GetUnitFromString(currentColumn.DefaultUOM != "" ? currentColumn.DefaultUOM : currentColumn.DBColumn.DefaultUOM), currentColumn)
        ]);
      }
    }
    else {
      finalArray.push({ text: "No Spec Info" }, { text: "" });
    }



    return finalArray;
  }

  GetUnitDisplayUOM(unitObj: Unit, dataColumn: MFGDBColumn) {
    if (dataColumn == undefined || dataColumn.UnitDisplay == "") {
      return this.convServ.GetUnitDisplayText(unitObj);
    }
    else {
      return dataColumn.UnitDisplay;
    }
  }

  GetDataValue(specType: string, column: MFGDBColumn, defaultValue: string): string {
    if (column.DBColumn.ColumnName.toLowerCase() != "custom" && (defaultValue == "" || defaultValue == null)) {
      if (specType == "Motor") {
        
        let str = column.DBColumn.ColumnName as keyof typeof this.Motor;
        if (column.DefaultUOM != "" && column.DBColumn.DefaultUOM != column.DefaultUOM) {
          return this.convServ.ConvertValue(parseFloat(this.Motor[str].toString()), new UnitObject(column.DBColumn.DisplayText, this.convServ.GetUnitFromString(column.DBColumn.DefaultUOM), this.convServ), new UnitObject(column.CustomText, this.convServ.GetUnitFromString(column.DefaultUOM), this.convServ)).toString().substring(0, 8);
        }
        else {
          return this.Motor[str] ? this.Motor[str].toString() : "";
        }
        
      } else {
        let str = column.DBColumn.ColumnName as keyof typeof this.FeedbackDevice;
        if (column.DefaultUOM != "" && column.DBColumn.DefaultUOM != column.DefaultUOM) {
          return this.convServ.ConvertValue(parseFloat(this.FeedbackDevice[str].toString()), new UnitObject(column.DBColumn.DisplayText, this.convServ.GetUnitFromString(column.DBColumn.DefaultUOM), this.convServ), new UnitObject(column.CustomText, this.convServ.GetUnitFromString(column.DefaultUOM), this.convServ)).toString().substring(0, 8);
        } else {
          return this.FeedbackDevice[str] ? this.FeedbackDevice[str].toString() : "";
        }
        
      }
    }
    else {
      return defaultValue;
    }

  }

  GetDefaultValue(specType: string, column: string) {
    var retValue = "";
    var columns: MFGDBColumn[] = [];
    var dbTable = specType == "Motor" ? "Motor" : "FeedbackDevice";
    if (dbTable == "Motor") {
      columns = this.Drive.MFG.MFGDBColumns.filter(x => x.DBTable == dbTable);
      if (columns.length == 0) {
        columns = this.TolomaticMFG.MFGDBColumns.filter(x => x.DBTable == dbTable);
      }
    }
    else {
      columns = this.GetFeedbackColumns(this.Drive.MFG.MFGDBColumns.filter(x => x.DBTable == dbTable))
      if (columns.length == 0) {
        columns = this.GetFeedbackColumns(this.TolomaticMFG.MFGDBColumns.filter(x => x.DBTable == dbTable));
      }
    }
    
    
    if (columns.filter(x => x.DBColumnName == column).length > 0) {
      retValue = columns.filter(x => x.DBColumnName == column)[0].DefaultValue;
    }

    return retValue;
  }

  GetUnitFromUOM(uom: string, dbColumnUOM: string) {
    return this.convServ.GetUnitFromString(uom == "" ? dbColumnUOM : uom);
  }


  DriveStartup_Click() {
    window.open('https://www.tolomatic.com/support/drive-integration-resources/', '_blank');
  }


}

